<template>
  <div
    :class="`modal fade show ${c.props?.class || ''}`"
    :style="{ display: 'block' }"
    v-if="isOpen"
  >
    <div
      class="modal-dialog"
      :class="classDialog"
    >
      <div class="modal-content">
        <div class="modal-header">
          <template v-if="c.props?.headerText">
            <h1 class="fs-4 fw-normal mb-0">{{ c.props.headerText }}</h1>
          </template>
          <select
            v-if="c.props?.options"
            class="form-select form-select-sm ms-4 w-auto"
            @change="onSelectChange"
          >
            <option
              v-for="(opt, index) in c.props.options"
              :key="index"
              :value="opt.value"
            >
              {{ opt.label }}
            </option>
          </select>
          <button
            type="button"
            class="btn-close ms-auto"
            :disabled="isLoading"
            @click="() => onClose(c.props?.hasCloseCallback || null)"
          ></button>
        </div>
        <div
          class="modal-body"
          :class="classBody"
        >
          <Ctxprovider
            :provide="c.provide"
            :key="c.id"
          >
            <component
              :is="c.component"
              v-bind="c.props"
              :ref="bindComponentRef"
              v-on="c.events"
            >
              {{ $t('common.loading') }}
            </component>
          </Ctxprovider>
        </div>
      </div>
    </div>
  </div>
  <Teleport to="body">
    <div
      class="modal-backdrop fade show"
      v-if="isOpen"
    ></div>
  </Teleport>
</template>

<script setup>
import { provide, ref, computed, watch, shallowRef, toValue } from 'vue'
import { useModalStack } from '@/stores/modalstack'
import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui'
import { syncRef } from '@vueuse/core'
import Ctxprovider from './ctxprovider.vue'

const modalStack = useModalStack()
const { stack } = storeToRefs(modalStack)
const { fullscreen } = storeToRefs(useUiStore())
const isOpen = ref(false)
const c = shallowRef()
const fs = ref(false)
const classDialog = computed(() => {
  const cl = {
    'fit-content': c.value.props?.fitContent,
    'modal-fullscreen': fs.value,
  }
  return cl
})
const classBody = computed(() => ({ 'px-1': fs.value }))

syncRef(fs, fullscreen, { direction: 'rtl' })

watch(isOpen, isOpen => {
  document.body.classList.toggle('modal-open', isOpen)
})

watch(
  stack,
  stack => {
    isOpen.value = stack.length > 0
    let _c = stack[stack.length - 1]
    if (!_c) {
      c.value = undefined
      return
    }

    const s = modalStack.stateGet(_c.id)
    if (s) {
      Object.assign(_c.props, s)
    }
    if (_c.provide) {
      for (const [k, v] of Object.entries(_c.provide)) {
        provide(k, toValue(v))
      }
    }
    c.value = _c
  },
  { deep: true }
)

provide('fullscreen', fs)

function onClose(data = null) {
  window.dispatchEvent(new CustomEvent('modalstack:close'))
  fs.value = fullscreen.value
  modalStack.pop(data)
}

function onSelectChange(e) {
  const value = e.target?.value
  if (typeof value !== 'string' || !value) return
  const opts = c.value?.props?.options
  if (opts && !opts.some(o => o.value === value)) return
  c.value?.props?.serviceSelectCallback?.(value)
}

function bindComponentRef(el) {
  if (c.value?.componentRef) {
    c.value.componentRef.value = el
  }
}

provide('modalstack', true)

// Предоставим функцию для блокировок элементов во время запросов
const isLoading = ref(false)
provide('setModalLoading', loading => (isLoading.value = loading))
</script>
